import axios from 'axios';
const getFirm = hashId => axios.get(`/resources/get_firm?hash_id=${hashId}`);
const getTemplate = hashId =>
  axios.get(`/resources/get_template?hash_id=${hashId}`);
const getQuestionnaireIdByTemplate = ({ hashId, username, taxYear }) =>
  axios.get(`/resources/get_questionnaire_id_by_template`, {
    params: {
      hash_id: hashId,
      username: username,
      tax_year: taxYear,
    },
  });
export default {
  getFirm,
  getTemplate,
  getQuestionnaireIdByTemplate,
};
